'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minutesBefore;


// WEBPACK FOOTER //
// ./~/sugar-date/number/minutesBefore.js